/**
 * @module app.um
 */

import { AuthWithLocalState } from 'app/um/models/local-state-extensions';


export class AssignAuthsPageContext {

    private selectedAuthsMap = new Map<string, Array<AuthWithLocalState>>();

    public clearSelectedAuths(ownerId?: string) {
        if(ownerId) {
            this.selectedAuthsMap.delete(ownerId);
        }
        else {
            this.selectedAuthsMap.clear();
        }
    }
    public getSelectedAuths(ownerId?: string): Array<AuthWithLocalState> {
        if(ownerId || ownerId === '') {
            return this.selectedAuthsMap.get(ownerId) || [];
        }
        else {
            const results: Array<AuthWithLocalState> = [];
            this.selectedAuthsMap.forEach(o => {
                results.push(...o);
            });
            return results;
        }
    }
    public setSelectedAuths(ownerId: string, auths: Array<AuthWithLocalState>) {
        this.selectedAuthsMap.set(ownerId, auths);
    }

    public clear(): void {
        this.selectedAuthsMap.clear();
    }

}
